import { render, staticRenderFns } from "./SideView.vue?vue&type=template&id=267a13e9&scoped=true"
import script from "./SideView.vue?vue&type=script&lang=js"
export * from "./SideView.vue?vue&type=script&lang=js"
import style0 from "./SideView.vue?vue&type=style&index=0&id=267a13e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a13e9",
  null
  
)

export default component.exports